import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { FilterType } from "@/lib/filters";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";
import { DisplayEmailType } from "@/types/emailType";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";

export const useEmailTypesListColumnOverrides = () =>
  useMemo(
    () => ({
      allowed_roles: {
        id: "allowed_roles",
        cell: ({ row }: { row: Row<DisplayEmailType> }) => {
          const roles = row.original.allowed_roles;
          if (!roles?.length) {
            return null;
          }
          return roles.map((role) => role.name).join(", ");
        },
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: Object.values(SYSTEM_ROLE_CODE),
              translationKey: "userRole",
              multiValueFilterType: FilterType.IncludesString,
            },
          },
        },
      },
    }),
    [],
  );
